import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Card, Button, Badge, Table } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import SimpleLineIcon from 'react-simple-line-icons'
import Tsn from '../../models/Tsn'
import Palette from '../../Palette'
import { FaArrowLeft } from 'react-icons/fa'
import { Dialog, DialogContent, Divider } from '@material-ui/core'
import moment from 'moment'
import textFormatter from '../../util/TextFormatter'
import Swal from 'sweetalert2'
import { Link } from 'react-router-dom'
import MemberTsn from '../../models/MemberTsn'

export default function TsnDetailPage() {

    const [isLoading, setIsLoading] = useState(false)
    const { id } = useParams()
    const [tsnData, setTsnData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [schedulesByDate, setSchedulesByDate] = useState({})
    const [selectedSchedule, setSelectedSchedule] = useState([])
    const [showSummaryDialog, setShowSummaryDialog] = useState(false)
    const [latestRegistrationData, setLatestRegistrationData] = useState(null)
    const [pendingRegistration, setPendingRegistration] = useState(null)
    const [disability, setDisability] = useState(false)
    const [disabilityDescription, setDisabilityDescription] = useState('')
    const [isTermsChecked, setIsTermsChecked] = useState(false)

    const [purchasedSchedule, setPurchasedSchedule] = useState([])

    // Get logged in user data
    const userData = JSON.parse(localStorage.getItem('user'))
    const memberId = userData?.id

    const fetchTsnDetails = async () => {
        try {
            setLoading(true)
            const response = await Tsn.getById(id)
            setTsnData(response)

            let defaultSelectedSchedule = []
            for(let d of response.details){
                if(d?.latest_registration_data?.registration_status === "ACCEPTED" ){
                    defaultSelectedSchedule.push(d)
                }
            }
            setPurchasedSchedule(defaultSelectedSchedule)

            const grouped = {}
            if (response.details) {
                response.details.forEach((detail) => {
                    const date = moment(detail.tsn_date).format('YYYY-MM-DD')
                    const hour = moment(detail.start_time, 'HH:mm').format('HH:00')

                    if (!grouped[date]) {
                        grouped[date] = {}
                    }
                    if (!grouped[date][hour]) {
                        grouped[date][hour] = []
                    }
                    grouped[date][hour].push(detail)
                })
            }

            if (response.start_time && response.end_time) {
                const allDates = generateDateRange(response.start_time, response.end_time)
                allDates.forEach((date) => {
                    if (!grouped[date]) {
                        grouped[date] = {}
                    }
                })
            }

            const sortedGrouped = {}
            Object.keys(grouped)
                .sort()
                .forEach((date) => {
                    sortedGrouped[date] = {}
                    Object.keys(grouped[date])
                        .sort()
                        .forEach((hour) => {
                            sortedGrouped[date][hour] = grouped[date][hour]
                        })
                })

            setSchedulesByDate(sortedGrouped)

            if (response.registration_data && response.registration_data.length > 0) {
                setLatestRegistrationData(response.registration_data[0])
            }
        } catch (error) {
            console.error('Failed to fetch TSN schedule:', error)
        } finally {
            setLoading(false)
        }
    }

    const checkPendingRegistration = async () => {
        try {
            if (!memberId) return

            const memberTsn = new MemberTsn()
            const response = await memberTsn.getByMemberAndTsn(memberId, id)

            if (response && response.length > 0 && response[0].status === 'WAITING') {
                setPendingRegistration(response[0])
            }
        } catch (error) {
            console.error('Failed to check pending registration:', error)
        }
    }

    const generateDateRange = (startDate, endDate) => {
        const dates = []
        const currentDate = moment(startDate)
        const lastDate = moment(endDate)

        while (currentDate.isSameOrBefore(lastDate)) {
            dates.push(currentDate.format('YYYY-MM-DD'))
            currentDate.add(1, 'day')
        }

        return dates
    }

    const handleAddCartSchedule = async (dataSchedule) => {

        let temp = [...selectedSchedule]

        const date = moment(dataSchedule.tsn_date).format('YYYY-MM-DD')
        const hour = moment(dataSchedule.start_time, 'HH:mm').format('HH:00')


        let detailWithSameSlot = schedulesByDate[date][hour]
        let detailWithSameSlotFiltered = detailWithSameSlot.filter(obj=>obj.id !== dataSchedule.id)

        // console.log("SBD", detailWithSameSlotFiltered)

        for(let dw of detailWithSameSlotFiltered){

            const existingIndexPurchased = purchasedSchedule.findIndex((item) => item.id === dw.id)
            console.log("SBD PURCHASED", purchasedSchedule, existingIndexPurchased, dw.id)

            if(existingIndexPurchased !== -1){
                let swalResult = await Swal.fire({
                    title: 'Aksi tidak bisa dilakukan',
                    text: 'Anda telah terdaftar di kelas lain',
                    icon: 'error',
                    confirmButtonText: 'Oke',
                    // cancelButtonText: 'Batal',
                    // showCancelButton: true,
                })
                return
            }

            const existingIndex = selectedSchedule.findIndex((item) => item.id === dw.id)
            console.log("SBD EXISTING", temp)
            if(existingIndex !== -1){

                let swalResult = await Swal.fire({
                    title: 'Konfirmasi',
                    text: 'Anda hanya bisa mendaftar ke dalam satu TSN dalam satu sesi, apakah anda yakin?',
                    icon: 'info',
                    confirmButtonText: 'Oke',
                    cancelButtonText: 'Batal',
                    showCancelButton: true,
                })

                if (!swalResult.isConfirmed) {
                    return
                }else{
                    temp.splice(existingIndex, 1)
                    console.log("SBD CONFIRMED, HARUSNYA GANTI", temp)
                }

            }
        }

        console.log("SBD CONFIRMED, HARUSNYA GANTI 2")

        // if (!grouped[date]) {
        //     grouped[date] = {}
        // }
        // if (!grouped[date][hour]) {
        //     grouped[date][hour] = []
        // }
        // grouped[date][hour].push(detail)

        const existingIndex = selectedSchedule.findIndex((item) => item.id === dataSchedule.id)
        if(existingIndex !== -1){
            temp.splice(existingIndex, 1)
        }else{
            temp.push(dataSchedule)
        }

        console.log("SBD setting", temp)
        setSelectedSchedule(temp)
    }

    const handleRegister = async () => {
        try {
            setIsLoading(true)
            const payload = {
                schedules: selectedSchedule,
                disability: disability,
                disability_description: disability ? disabilityDescription : '',
            }

            console.log('Data yang dikirim ke API:', payload)

            const result = await Tsn.register(id, payload)

            if (!result.snap_payment_url) {
                Swal.fire('Error', 'Gagal melakukan pendaftaran', 'error')
                return
            }

            window.location.href = result.snap_payment_url
        } catch (error) {
            console.error('Error saat registrasi:', error)
            Swal.fire('Error', error.error_message || 'Gagal melakukan pendaftaran', 'error')
        }
        setIsLoading(false)
    }

    useEffect(() => {
        fetchTsnDetails()
        checkPendingRegistration()
    }, [id, memberId])

    const renderPendingRegistration = () => {
        if (!pendingRegistration) return null
    
        const isMobile = window.innerWidth < 768 // Optional: Bisa pakai hook useMediaQuery juga
    
        return (
            <Row className="mb-4" style={{ gap: 0 }}>
                <Col md={isMobile ? 12 : 9} xs={12} className="mb-3 mb-md-0">
                    <Card className="border-0">
                        <Card.Body className="border rounded mb-4">
                            <h5 className="mb-3">Pembayaran Berlangsung</h5>
    
                            {/* MOBILE STYLE */}
                            {isMobile ? (
                                <>
                                    {pendingRegistration.details.map((detail, index) => (
                                        <div
                                            key={index}
                                            className="border rounded p-3 mb-3"
                                            style={{ background: '#f8f9fa' }}
                                        >
                                            <div className="mb-2">
                                                <strong>Item:</strong> {detail.certificate_name}
                                            </div>
                                            <div className="mb-2">
                                                <strong>Hari:</strong>{' '}
                                                {moment(detail.tsn_date).format('dddd, DD MMMM YYYY')}
                                            </div>
                                            <div className="mb-2">
                                                <strong>Waktu:</strong>{' '}
                                                {detail.start_time && detail.end_time
                                                    ? `${moment(detail.start_time, 'HH:mm:ss').format('HH:mm')} - ${moment(
                                                          detail.end_time,
                                                          'HH:mm:ss',
                                                      ).format('HH:mm')}`
                                                    : '-'}
                                            </div>
                                            <div className="mb-2">
                                                <strong>Harga:</strong> Rp
                                                {textFormatter.moneyFormatter(detail.price)}
                                            </div>
    
                                            <hr />
    
                                            <div className="mb-2">
                                                <strong>Ringkasan</strong>
                                            </div>
                                            <div className="d-flex justify-content-between mb-1">
                                                <span>Item</span>
                                                <span>{pendingRegistration.details.length}</span>
                                            </div>
                                            <div className="d-flex justify-content-between mb-1">
                                                <span>Harga</span>
                                                <span>
                                                    Rp
                                                    {textFormatter.moneyFormatter(detail.price)}
                                                </span>
                                            </div>
                                            <div className="d-flex justify-content-between mt-2 fw-bold">
                                                <span>Subtotal</span>
                                                <span>
                                                    Rp
                                                    {textFormatter.moneyFormatter(pendingRegistration.total_price)}
                                                </span>
                                            </div>
    
                                            <a
                                                target="_blank"
                                                href={latestRegistrationData.snap_payment_url}
                                                style={{ pointerEvents: 'auto' }}
                                                tabIndex={0}
                                            >
                                                <Button
                                                    style={{
                                                        fontFamily: 'Signika',
                                                        fontWeight: '600',
                                                        backgroundColor: Palette.PRIMARY,
                                                        borderColor: Palette.PRIMARY,
                                                        fontSize: '16px',
                                                        width: '100%',
                                                        marginTop: '1rem',
                                                    }}
                                                >
                                                    Lanjutkan Pembayaran
                                                </Button>
                                            </a>
                                        </div>
                                    ))}
                                </>
                            ) : (
                                // DESKTOP STYLE (tetap pakai table)
                                <Table borderless responsive className="mb-3">
                                    <thead>
                                        <tr>
                                            <th>Item</th>
                                            <th>Hari</th>
                                            <th>Waktu</th>
                                            <th>Harga</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pendingRegistration.details.map((detail, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <span className="fw-bold">{detail.certificate_name}</span>
                                                </td>
                                                <td>
                                                    {moment(detail.tsn_date).format('dddd, DD MMMM YYYY')}
                                                </td>
                                                <td>
                                                    {detail.start_time && detail.end_time
                                                        ? `${moment(detail.start_time, 'HH:mm:ss').format('HH:mm')} - ${moment(
                                                              detail.end_time,
                                                              'HH:mm:ss',
                                                          ).format('HH:mm')}`
                                                        : '-'}
                                                </td>
                                                <td>
                                                    Rp
                                                    {textFormatter.moneyFormatter(detail.price)}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
    
                {/* DESKTOP RINGKASAN */}
                {!isMobile &&
                    latestRegistrationData &&
                    latestRegistrationData.status === 'WAITING' && (
                        <Col md={3} xs={12}>
                            <Card>
                                <Card.Body>
                                    <div className="mb-2" style={{ paddingLeft: 0 }}>
                                        <strong>Ringkasan</strong>
                                    </div>
                                    <div
                                        style={{
                                            background: '#f8f9fa',
                                            borderRadius: 8,
                                            padding: '12px 16px',
                                            marginBottom: 12,
                                            textAlign: 'left',
                                            fontSize: 14,
                                        }}
                                    >
                                        <div className="mb-2">
                                            <strong>Summary</strong>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span>Item</span>
                                            <span>{pendingRegistration.details.length}</span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span>Harga</span>
                                            <span>
                                                Rp
                                                {textFormatter.moneyFormatter(pendingRegistration.details[0].price)}
                                            </span>
                                        </div>
                                        <hr style={{ margin: '8px 0' }} />
                                        <div
                                            className="d-flex justify-content-between mt-2"
                                            style={{ fontWeight: 'bold' }}
                                        >
                                            <span>Subtotal</span>
                                            <span>
                                                Rp
                                                {textFormatter.moneyFormatter(pendingRegistration.total_price)}
                                            </span>
                                        </div>
                                    </div>
                                    <a
                                        target="_blank"
                                        href={latestRegistrationData.snap_payment_url}
                                        style={{ pointerEvents: 'auto' }}
                                        tabIndex={0}
                                    >
                                        <Button
                                            style={{
                                                fontFamily: 'Signika',
                                                fontWeight: '600',
                                                backgroundColor: Palette.PRIMARY,
                                                borderColor: Palette.PRIMARY,
                                                fontSize: '16px',
                                                width: '100%',
                                            }}
                                            className="mr-2 mb-4"
                                        >
                                            Lanjutkan Pembayaran
                                        </Button>
                                    </a>
                                </Card.Body>
                            </Card>
                        </Col>
                    )}
            </Row>
        )
    }
    

    const renderActionButton = (schedule) => {
        if (schedule?.latest_registration_data?.registration_status === 'ACCEPTED') {
            return (
                <Button
                    style={{
                        fontFamily: 'Signika',
                        fontWeight: '600',
                        width: '100%',
                        fontSize: '16px',
                        backgroundColor: Palette.GREEN,
                        borderColor: Palette.GREEN,
                    }}
                    variant="primary"
                    className="mt-3 px-5 py-2"
                    size="lg"
                >
                    Terdaftar
                </Button>
            )
        }

        return (
            <Button
                onClick={() => {
                    handleAddCartSchedule(schedule)

                }}
                style={{
                    fontFamily: 'Signika',
                    fontWeight: '600',
                    width: '100%',
                    fontSize: '16px',
                    backgroundColor: selectedSchedule.some((item) => item.id === schedule.id)
                        ? Palette.GREY
                        : Palette.PRIMARY,
                    borderColor: Palette.PRIMARY,
                }}
                variant="primary"
                className="mt-3 px-5 py-2"
                size="lg"
            >
                {selectedSchedule.some((item) => item.id === schedule.id)
                    ? 'Batalkan Pilihan'
                    : 'Pilih Jadwal'}
            </Button>
        )
    }

    if (loading) {
        return (
            <Container className="py-4">
                <div className="text-center">Loading...</div>
            </Container>
        )
    }

    if (!tsnData) {
        return (
            <Container className="py-4">
                <div className="text-center">Data not found</div>
            </Container>
        )
    }

    return (
        <>
            <Container className="py-4">
                <Row className="mb-4">
                    <Link style={{ color: '#000000' }} className={'d-flex'} to={'/tsn'}>
                        <FaArrowLeft style={{ paddingTop: '0.3rem', fontSize: 16 }} />
                        <span style={{ fontWeight: 'bold', fontSize: 16 }}>Kembali ke TSN</span>
                    </Link>
                </Row>

                {/* Display pending registration */}
                {renderPendingRegistration()}

                <Row className="mb-4">
                    <Col lg={6}>
                        <Card className="border-0 shadow-sm position-relative">
                            <Card.Img src={tsnData.image_url} style={{ objectFit: 'cover' }} />
                        </Card>
                    </Col>

                    <Col lg={6}>
                        <Row className="mb-2">
                            <Col className="text-left">
                                <h4 className="mt-3">{tsnData.name}</h4>
                            </Col>
                        </Row>

                        <div style={{ gap: 20 }} className="d-flex flex-column">
                            <Row>
                                <Col>
                                    <div style={{ gap: 25 }} className="d-flex  mb-2">
                                        <SimpleLineIcon
                                            name="calendar"
                                            style={{ color: Palette.PRIMARY, paddingTop: '0.3rem' }}
                                        />
                                        <div className="d-flex flex-column">
                                            <span
                                                style={{
                                                    fontSize: 18,
                                                    fontWeight: 'bold',
                                                    color: Palette.PRIMARY,
                                                }}
                                            >
                                                Tanggal
                                            </span>
                                            <span className="text-dark">
                                                {moment(tsnData.start_time).isValid() &&
                                                moment(tsnData.end_time).isValid()
                                                    ? moment(tsnData.start_time).format(
                                                          'DD MMMM YYYY',
                                                      ) ===
                                                      moment(tsnData.end_time).format(
                                                          'DD MMMM YYYY',
                                                      )
                                                        ? moment(tsnData.start_time).format(
                                                              'DD MMMM YYYY',
                                                          )
                                                        : `${moment(tsnData.start_time).format(
                                                              'DD MMMM YYYY',
                                                          )} - ${moment(tsnData.end_time).format(
                                                              'DD MMMM YYYY',
                                                          )}`
                                                    : ''}
                                            </span>
                                        </div>
                                    </div>

                                    <Divider />
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <div style={{ gap: 25 }} className="d-flex  mb-2">
                                        <SimpleLineIcon
                                            name="clock"
                                            style={{ color: Palette.PRIMARY, paddingTop: '0.3rem' }}
                                        />
                                        <div className="d-flex flex-column">
                                            <span
                                                style={{
                                                    fontSize: 18,
                                                    fontWeight: 'bold',
                                                    color: Palette.PRIMARY,
                                                }}
                                            >
                                                Waktu
                                            </span>
                                            <span className="text-dark">
                                                {moment(tsnData?.start_time).isValid()
                                                    ? moment(tsnData?.start_time).format('HH:mm')
                                                    : ''}{' '}
                                                -{' '}
                                                {moment(tsnData?.end_time).isValid()
                                                    ? moment(tsnData?.end_time).format('HH:mm')
                                                    : ''}
                                            </span>
                                        </div>
                                    </div>

                                    <Divider />
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <div style={{ gap: 25 }} className="d-flex  mb-2">
                                        <SimpleLineIcon
                                            name="tag"
                                            style={{ color: Palette.PRIMARY, paddingTop: '0.3rem' }}
                                        />
                                        <div className="d-flex flex-column">
                                            <span
                                                style={{
                                                    fontSize: 18,
                                                    fontWeight: 'bold',
                                                    color: Palette.PRIMARY,
                                                }}
                                            >
                                                Harga
                                            </span>
                                            <span className="text-dark">
                                                {`Rp${textFormatter.moneyFormatter(tsnData.price)}`}
                                            </span>
                                        </div>
                                    </div>

                                    <Divider />
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <div style={{ gap: 25 }} className="d-flex  mb-2">
                                        <SimpleLineIcon
                                            name="location-pin"
                                            style={{ color: Palette.PRIMARY, paddingTop: '0.3rem' }}
                                        />
                                        <div className="d-flex flex-column">
                                            <span
                                                style={{
                                                    fontSize: 18,
                                                    fontWeight: 'bold',
                                                    color: Palette.PRIMARY,
                                                }}
                                            >
                                                Lokasi
                                            </span>
                                            <span className="text-dark">{tsnData.location}</span>
                                        </div>
                                    </div>

                                    <Divider />
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
                <Row className="mb-4">
                    <Col>
                        <p className="text-muted lh-lg">{tsnData.disability_description}</p>
                    </Col>
                </Row>

                <Card>
                    <Card.Header className="d-flex bg-transparent border-0 justify-content-between align-items-center">
                        <Card.Title>Jadwal TSN</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        {Object.keys(schedulesByDate).length > 0 ? (
                            Object.entries(schedulesByDate).map(([date, hourGroups]) => (
                                <div key={date} className="mb-4">
                                    <h5 className="text-muted mb-3">
                                        {moment(date).format('dddd, DD MMMM YYYY')}
                                    </h5>
                                    <Divider className="mb-4" />

                                    {Object.entries(hourGroups).map(([hour, schedules]) => (
                                        <div key={`${date}-${hour}`} className="mb-4">
                                            <h6
                                                className="text-primary mb-3"
                                                style={{ color: Palette.PRIMARY }}
                                            >
                                                {moment(hour, 'HH:mm').format('HH:mm')} -{' '}
                                                {moment(hour, 'HH:mm')
                                                    .add(1, 'hour')
                                                    .format('HH:mm')}
                                            </h6>
                                            <Row>
                                                {schedules.map((schedule, index) => (
                                                    <Col key={index} md={4} className="mb-3">
                                                        <Card className="h-100 shadow-sm position-relative">
                                                            <Card.Header className="bg-white">
                                                                <Card.Title
                                                                    className="mb-3 fw-semibold"
                                                                    style={{
                                                                        fontSize: '18px',
                                                                        color: Palette.PRIMARY,
                                                                    }}
                                                                >
                                                                    {schedule?.certificate_name ||
                                                                        '-'}
                                                                </Card.Title>
                                                            </Card.Header>

                                                            <Card.Body className="d-flex flex-column">
                                                                <Row className="mb-3 g-2">
                                                                    <Col xs={6}>
                                                                        <div
                                                                            className="rounded py-1 text-center"
                                                                            style={{
                                                                                minHeight: '40px',
                                                                                background:
                                                                                    Palette.LIGHT_GRAY,
                                                                                border: `1px solid ${Palette.PRIMARY}`,
                                                                                borderRadius: 10,
                                                                            }}
                                                                        >
                                                                            <small className="text-muted d-block">
                                                                                Pasangan Bahasa
                                                                            </small>
                                                                            <strong className="small">
                                                                                {
                                                                                    schedule?.language_from_name
                                                                                }
                                                                                -
                                                                                {
                                                                                    schedule?.language_to_name
                                                                                }
                                                                            </strong>
                                                                        </div>
                                                                    </Col>
                                                                    <Col xs={6}>
                                                                        <div
                                                                            className="rounded py-1 text-center"
                                                                            style={{
                                                                                minHeight: '40px',
                                                                                background:
                                                                                    Palette.LIGHT_GRAY,
                                                                                border: `1px solid ${Palette.PRIMARY}`,
                                                                                borderRadius: 10,
                                                                            }}
                                                                        >
                                                                            <small className="text-muted d-block">
                                                                                Jenis Sertifikat
                                                                            </small>
                                                                            <strong className="small">
                                                                                {
                                                                                    schedule?.certificate_category === "TRANSLATOR" ? "PENERJEMAH" :
                                                                                        schedule?.certificate_category === "TRANSLATOR_EDITOR" ? "EDITOR TERJEMAHAN" :
                                                                                            schedule?.certificate_category === "INTERPRETER" ? "JURU BAHASA" : schedule?.certificate_category
                                                                                }
                                                                            </strong>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                {renderActionButton(schedule)}
                                                            </Card.Body>
                                                        </Card>
                                                    </Col>
                                                ))}
                                            </Row>
                                        </div>
                                    ))}
                                </div>
                            ))
                        ) : (
                            <div className="text-center text-muted">Tidak ada jadwal tersedia</div>
                        )}
                    </Card.Body>
                </Card>

                {selectedSchedule.length > 0 && (
                    <div
                        style={{
                            position: 'fixed',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            backgroundColor: '#FFFFFF',
                            padding: '30px 20px',
                            zIndex: 1000,
                        }}
                        className="mt-4"
                    >
                        <Container>
                            <Button
                                onClick={() => {
                                    setShowSummaryDialog(true)
                                    console.log('schedule yang dipilih', selectedSchedule)
                                }}
                                style={{
                                    width: '100%',
                                    borderRadius: 10,
                                    height: 60,
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    flexDirection: 'row',
                                    backgroundColor: Palette.PRIMARY,
                                    alignItems: 'center',
                                }}
                            >
                                <div
                                    className="text-white px-3"
                                    style={{ fontSize: 18, fontWeight: 'bold' }}
                                >
                                    {selectedSchedule.length > 0
                                        ? `${selectedSchedule.length} Item`
                                        : 'Tidak ada jadwal yang dipilih'}
                                </div>
                                <div style={{ gap: 10 }} className="d-flex align-items-center">
                                    <span
                                        className="text-white"
                                        style={{ fontSize: 18, fontWeight: 'bold' }}
                                    >
                                        {`Rp.${textFormatter.moneyFormatter(
                                            selectedSchedule.reduce(
                                                (total, item) => total + tsnData.price,
                                                0,
                                            ),
                                        )}`}
                                    </span>
                                    <SimpleLineIcon name="bag" />
                                </div>
                            </Button>
                        </Container>
                    </div>
                )}
            </Container>
            <Dialog
                open={showSummaryDialog}
                onClose={() => setShowSummaryDialog(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogContent style={{ padding: '24px' }}>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h5 style={{ margin: 0, fontWeight: 'bold', fontSize: '20px' }}>
                            Pembelianmu
                        </h5>
                        {selectedSchedule.length > 0 && (
                            <Button
                                variant="link"
                                onClick={() => {
                                    setSelectedSchedule([])
                                    setShowSummaryDialog(false)
                                }}
                                style={{
                                    color: '#000000',
                                    textDecoration: 'none',
                                    fontSize: '16px',
                                    padding: 0,
                                }}
                            >
                                Hapus Semua
                            </Button>
                        )}
                    </div>

                    <div style={{ maxHeight: 350, overflowY: 'scroll' }} className="mb-4">
                        {selectedSchedule.map((schedule, index) => {
                            const formattedTsnDate = moment(schedule).format('YYYY-MM-DD')

                            const formattedSessionTime =
                                moment(`${formattedTsnDate} ${schedule?.start_time}`).isValid() &&
                                moment(`${formattedTsnDate} ${schedule?.end_time}`).isValid()
                                    ? `${moment(
                                          `${formattedTsnDate} ${schedule?.start_time}`,
                                      ).format('HH:mm')} - ${moment(
                                          `${formattedTsnDate} ${schedule?.end_time}`,
                                      ).format('HH:mm')}`
                                    : '-'

                            return (
                                <>
                                    <div
                                        key={schedule.id}
                                        className="d-flex align-items-center mb-3"
                                        style={{ padding: '12px 0' }}
                                    >
                                        <div className="flex-grow-1">
                                            <h6
                                                style={{
                                                    margin: 0,
                                                    marginBottom: '4px',
                                                    fontSize: '16px',
                                                    fontWeight: '600',
                                                    color: Palette.PRIMARY,
                                                }}
                                            >
                                                {schedule.certificate_name || tsnData.name}
                                            </h6>
                                            <div
                                                className="d-flex align-items-center mb-1 mt-2"
                                                style={{ gap: '8px', color: '#666' }}
                                            >
                                                <span style={{ fontSize: 14 }}>
                                                    {formattedSessionTime}
                                                </span>
                                            </div>

                                            <p
                                                style={{
                                                    margin: 0,
                                                    fontSize: '14px',
                                                    color: '#666',
                                                    fontWeight: '500',
                                                }}
                                            >
                                                {`Rp${textFormatter.moneyFormatter(tsnData.price)}`}
                                            </p>
                                        </div>

                                        <Button
                                            variant="link"
                                            onClick={() => handleAddCartSchedule(schedule)}
                                            style={{
                                                color: Palette.GREY,
                                                padding: '8px',
                                                fontSize: '18px',
                                            }}
                                        >
                                            <SimpleLineIcon name="trash" />
                                        </Button>
                                    </div>
                                </>
                            )
                        })}
                    </div>

                    <div
                        style={{
                            backgroundColor: '#f8f9fa',
                            padding: '20px',
                            borderRadius: '12px',
                            marginBottom: '24px',
                        }}
                    >
                        <h6
                            style={{
                                margin: 0,
                                marginBottom: '16px',
                                fontSize: '16px',
                                fontWeight: 'bold',
                            }}
                        >
                            Summary
                        </h6>

                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <span style={{ fontSize: '14px', color: '#666' }}>Item</span>
                            <span style={{ fontSize: '14px', fontWeight: '500' }}>
                                {selectedSchedule.length}
                            </span>
                        </div>

                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <span style={{ fontSize: '14px', color: '#666' }}>Harga</span>
                            <span style={{ fontSize: '14px', fontWeight: '500' }}>
                                {`Rp${textFormatter.moneyFormatter(tsnData.price)}`}
                            </span>
                        </div>

                        <Divider style={{ margin: '12px 0' }} />

                        <div className="d-flex justify-content-between align-items-center">
                            <span style={{ fontSize: '16px', fontWeight: 'bold' }}>Subtotal</span>
                            <span style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                {`Rp${textFormatter.moneyFormatter(
                                    selectedSchedule.reduce(
                                        (total, item) => total + tsnData.price,
                                        0,
                                    ),
                                )}`}
                            </span>
                        </div>
                    </div>

                    <div className="mb-3">
                        <label className="form-label" style={{ fontWeight: 'bold' }}>
                            Apakah Anda penyandang disabilitas?
                        </label>
                        <div className="d-flex gap-3 mb-3">
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="disabilityRadio"
                                    id="disabilityYes"
                                    checked={disability}
                                    onChange={() => setDisability(true)}
                                />
                                <label className="form-check-label" htmlFor="disabilityYes">
                                    Ya
                                </label>
                            </div>
                            <div className="form-check" style={{ marginLeft: '1.5rem' }}>
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="disabilityRadio"
                                    id="disabilityNo"
                                    checked={!disability}
                                    onChange={() => setDisability(false)}
                                />
                                <label className="form-check-label" htmlFor="disabilityNo">
                                    Tidak
                                </label>
                            </div>
                        </div>

                        {disability && (
                            <div className="mb-3">
                                <textarea
                                    className="form-control"
                                    id="disabilityDescription"
                                    rows={3}
                                    value={disabilityDescription}
                                    onChange={(e) => setDisabilityDescription(e.target.value)}
                                    placeholder="Silakan jelaskan kebutuhan khusus Anda"
                                />
                            </div>
                        )}
                    </div>

                    <div className="mb-3">
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="termsCheckbox"
                                style={{ marginRight: '8px' }}
                                checked={isTermsChecked}
                                onChange={(e) => setIsTermsChecked(e.target.checked)}
                            />
                            <label
                                className="form-check-label"
                                htmlFor="termsCheckbox"
                                style={{ fontSize: '14px' }}
                            >
                                Dengan menekan tombol bayar, anda menyatakan setuju untuk tunduk
                                pada semua <Link target={"_blank"} to={"/tsn-terms-and-condition"}>syarat dan ketentuan</Link> yang berlaku sehubungan dengan
                                penyelenggaraan test sertifikasi nasional Himpunan Penerjemah
                                Indonesia 2025
                            </label>
                        </div>
                    </div>

                    <Button
                        style={{
                            width: '100%',
                            height: '50px',
                            backgroundColor: Palette.PRIMARY,
                            borderColor: Palette.PRIMARY,
                            borderRadius: '12px',
                            fontSize: '16px',
                            fontWeight: 'bold',
                        }}
                        variant="primary"
                        disabled={!isTermsChecked || isLoading}
                        onClick={async () => {
                            if (
                                latestRegistrationData &&
                                latestRegistrationData?.status === 'WAITING'
                            ) {
                                let result = await Swal.fire({
                                    title: 'Konfirmasi',
                                    text: 'Sedang ada pembayaran yang berlangsung. Jika pembayaran ini dilanjutkan, maka pembayaran sebelumnya akan digantikan.',
                                    icon: 'info',
                                    confirmButtonText: 'Oke',
                                    cancelButtonText: 'Batal',
                                    showCancelButton: true,
                                })
                                console.log('SWALRESULT', result)

                                if (result.isConfirmed) {
                                    handleRegister()
                                }
                            } else {
                                handleRegister()
                            }
                        }}
                    >
                        Bayar
                    </Button>
                </DialogContent>
            </Dialog>
        </>
    )
}
